import React from 'react';
import classes from './Toolbar.css';
//import Logo from '../../Logo/Logo';
import NavItems from '../NavItems/NavItems';
import Aux from '../../../hoc/Aux';
import ToggleButton from '../ToggleButton/ToggleButton';


const Toolbar=(props)=> (
	<Aux>
		<ToggleButton click={props.toggler}/>
		<header className={classes.Toolbar}>	
			<nav className={classes.DesktopOnly}>
			<NavItems isAuth ={props.isAuth}/>
			</nav>
		</header>
	</Aux>
	)

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Navigation/Toolbar/Toolbar.jsx